var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagSomeone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58843 11.121C7.58843 10.0065 8.06601 8.99729 8.83449 8.27221C8.40158 7.55074 7.81076 7.00722 7.04326 6.62476C6.41086 7.04337 5.64536 7.28883 4.82124 7.28883C3.99951 7.28883 3.23603 7.0448 2.6047 6.6284C1.00566 7.45992 0 9.19045 0 11.1887V14.2541H9.16952C8.20709 13.5222 7.58843 12.3898 7.58843 11.121Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51882 6.34793C7.1492 5.97736 8.15846 4.40611 7.77307 2.83846C7.38768 1.2708 5.75358 0.300373 4.1232 0.670943C2.49282 1.04151 1.48356 2.61275 1.86895 4.18041C2.25434 5.74807 3.88844 6.7185 5.51882 6.34793Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 11.121C15.0002 9.39347 13.5385 7.98798 11.7418 7.98798C9.94511 7.98798 8.4834 9.39347 8.4834 11.121C8.4834 12.8486 9.94511 14.2541 11.7418 14.2541C13.5385 14.2541 15.0002 12.8487 15.0002 11.121ZM9.84392 11.5511V10.691H11.2945V9.2962H12.189V10.691H13.6396V11.5511H12.189V12.9459H11.2945V11.5511H9.84392Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagSomeone);
export default __webpack_public_path__ + "static/media/tag_someone.993beb5816b181f1758b08becb1dca28.svg";
export { ForwardRef as ReactComponent };